export const RESET = 'searchFilters/reset';

export const createResetAction = filterName => () => ({
  type: RESET,
  payload: { filterName },
});

export const SEARCH = 'searchFilters/search';
export const SEARCH_START = `${SEARCH}_START`;
export const SEARCH_SUCCESS = `${SEARCH}_SUCCESS`;
export const SEARCH_FAIL = `${SEARCH}_FAIL`;

export const createSearchAction =
  ({ filterName, uri, params }) =>
  ({ value, startIndex, stopIndex, ...otherParams }) => ({
    type: SEARCH,
    payload: { filterName, startIndex, stopIndex },
    meta: {
      xmApi: true,
      method: 'get',
      uri,
      params: {
        search: !value ? undefined : value,
        offset: startIndex,
        limit: Math.max(1, stopIndex - startIndex),
        ...params,
        ...otherParams,
      },
    },
  });
